import { NgClass, UpperCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';

import { OrderIntegration } from '@cure-common/enum';

@Component({
  selector: 'app-integration-chip',
  standalone: true,
  imports: [NgClass, UpperCasePipe],
  templateUrl: './integration-chip.component.html',
  styleUrl: './integration-chip.component.scss',
})
export class IntegrationChipComponent {
  @Input() integration: OrderIntegration;
  constructor() {}
}
